/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import { reducer as notifications } from 'react-notification-system-redux';

import appReducer from 'store/ducks/app';
import authReducer from 'store/ducks/auth';
import authErrorReducer from 'store/ducks/authError';
import productReducer from 'store/ducks/product';
import storeReducer from 'store/ducks/stores';
import cityReducer from 'store/ducks/city';
import userReducer from 'store/ducks/user';
import childrenReducer from 'store/ducks/children';
import groupReducer from 'store/ducks/group';
import orderReducer from 'store/ducks/order';
import pageReducer from 'store/ducks/page';
import profileAccessReducer from 'store/ducks/profileAccess';
import productColorReducer from 'store/ducks/productColor';
import productSizeReducer from 'store/ducks/productSize';
import bankReducer from 'store/ducks/bank';
import bannerReducer from 'store/ducks/banner';
import addressReducer from 'store/ducks/address';
import trendReducer from 'store/ducks/trend';
import kitReducer from 'store/ducks/kit';
import reportReducer from 'store/ducks/report';
import walletReducer from 'store/ducks/wallet';
import shoppingReducer from 'store/ducks/shopping';
import virtualCatalogReducer from 'store/ducks/virtualCatalog';
import scrollReducer from 'store/ducks/scroll';
import couponReducer from 'store/ducks/coupon';
import dashboardReducer from 'store/ducks/dashboard';
import dashboardGeneralReducer from 'store/ducks/dashboard/general';
import dashboardTimelineReducer from 'store/ducks/dashboard/timeline';
import withdrawReducer from 'store/ducks/wallet/withdraw';
import categoryItemReducer from './category';
import categoryListReducer from './category/list';
import categoryUpdateReducer from './category/update';
import categoryInsertReducer from './category/insert';
import categoryDeleteReducer from './category/delete';
import publicGlobal from './publicGlobal';
import globalItemReducer from './global';
import globalUpdateReducer from './global/update';
import moduleListReducer from './module/list';
import categoryModuleListReducer from './module/category/list';
import categoryModuleItemReducer from './module/category';
import categoryModuleUpdateReducer from './module/category/update';
import categoryModuleInsertReducer from './module/category/insert';
import categoryModuleDeleteReducer from './module/category/delete';
import modulesInsertReducer from './module/insert';
import modulesUpdateReducer from './module/update';
import moduleByIdReducer from './module';
import moduleDeleteReducer from './module/delete';
import activitiesByModuleReducer from './module/activity/byModule';
import activityModuleInsertReducer from './module/activity/insert';
import activityModuleUpdateReducer from './module/activity/update';
import activityByIdReducer from './module/activity';
import activityModuleDeleteReducer from './module/activity/delete';
import attachmentModuleInsertReducer from './attachment/insert';
import attachmentModuleByActivityReducer from './attachment/byActivity';
import attachmentModuleByModuleReducer from './attachment/byModule';
import attachmentModuleDeleteReducer from './attachment/delete';
import attachmentModuleReducer from './attachment';
import blogCategoryItemReducer from './blog/category';
import blogCategoryListReducer from './blog/category/list';
import blogCategoryUpdateReducer from './blog/category/update';
import blogCategoryInsertReducer from './blog/category/insert';
import blogCategoryDeleteReducer from './blog/category/delete';
import groupChildItemReducer from './groupChild';
import groupChildListReducer from './groupChild/list';
import groupChildUpdateReducer from './groupChild/update';
import groupChildInsertReducer from './groupChild/insert';
import groupChildDeleteReducer from './groupChild/delete';
import interestItemReducer from './interest';
import interestListReducer from './interest/list';
import interestUpdateReducer from './interest/update';
import interestInsertReducer from './interest/insert';
import interestDeleteReducer from './interest/delete';
import attachmentModuleUpdateReducer from './attachment/update';
import blogPostItemReducer from './blog/post';
import blogPostListReducer from './blog/post/list';
import blogPostUpdateReducer from './blog/post/update';
import blogPostInsertReducer from './blog/post/insert';
import blogPostDeleteReducer from './blog/post/delete';
import passwordRecovery from './account/passwordRecovery';
import validateHash from './account/validate';
import validateAccount from './account/validateAccount';

import globalsStatusReducer from './globalsStatus/actions';

import reportsActivitiesDoneReducer from './reportsActivities/list';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default history =>
  combineReducers({
    router: connectRouter(history),
    notifications,
    publicGlobal,
    app: appReducer,
    product: productReducer,
    auth: authReducer,
    authError: authErrorReducer,
    store: storeReducer,
    globalsStatus: globalsStatusReducer,
    city: cityReducer,
    user: userReducer,
    children: childrenReducer,
    group: groupReducer,
    order: orderReducer,
    page: pageReducer,
    profileAccess: profileAccessReducer,
    productColor: productColorReducer,
    productSize: productSizeReducer,
    bank: bankReducer,
    banner: bannerReducer,
    address: addressReducer,
    trend: trendReducer,
    kit: kitReducer,
    report: reportReducer,
    wallet: walletReducer,
    shopping: shoppingReducer,
    virtualCatalog: virtualCatalogReducer,
    scroll: scrollReducer,
    coupon: couponReducer,
    dashboard: combineReducers({
      dashboard: dashboardReducer,
      general: dashboardGeneralReducer,
      timeline: dashboardTimelineReducer,
    }),
    withdraw: withdrawReducer,
    module: combineReducers({
      module: moduleByIdReducer,
      list: moduleListReducer,
      insert: modulesInsertReducer,
      update: modulesUpdateReducer,
      delete: moduleDeleteReducer,
      category: combineReducers({
        list: categoryModuleListReducer,
        category: categoryModuleItemReducer,
        update: categoryModuleUpdateReducer,
        insert: categoryModuleInsertReducer,
        delete: categoryModuleDeleteReducer,
      }),
      activity: combineReducers({
        activity: activityByIdReducer,
        byModule: activitiesByModuleReducer,
        insert: activityModuleInsertReducer,
        update: activityModuleUpdateReducer,
        delete: activityModuleDeleteReducer,
      }),
    }),
    category: combineReducers({
      category: categoryItemReducer,
      list: categoryListReducer,
      insert: categoryInsertReducer,
      update: categoryUpdateReducer,
      delete: categoryDeleteReducer,
    }),
    global: combineReducers({
      global: globalItemReducer,
      update: globalUpdateReducer,
    }),
    attachmentModule: combineReducers({
      attachmentModule: attachmentModuleReducer,
      insert: attachmentModuleInsertReducer,
      byActivity: attachmentModuleByActivityReducer,
      byModule: attachmentModuleByModuleReducer,
      delete: attachmentModuleDeleteReducer,
      update: attachmentModuleUpdateReducer,
    }),
    blog: combineReducers({
      category: combineReducers({
        category: blogCategoryItemReducer,
        list: blogCategoryListReducer,
        insert: blogCategoryInsertReducer,
        update: blogCategoryUpdateReducer,
        delete: blogCategoryDeleteReducer,
      }),
      post: combineReducers({
        post: blogPostItemReducer,
        list: blogPostListReducer,
        insert: blogPostInsertReducer,
        update: blogPostUpdateReducer,
        delete: blogPostDeleteReducer,
      }),
    }),
    groupChild: combineReducers({
      groupChild: groupChildItemReducer,
      list: groupChildListReducer,
      insert: groupChildInsertReducer,
      update: groupChildUpdateReducer,
      delete: groupChildDeleteReducer,
    }),
    interest: combineReducers({
      interest: interestItemReducer,
      list: interestListReducer,
      insert: interestInsertReducer,
      update: interestUpdateReducer,
      delete: interestDeleteReducer,
    }),
    account: combineReducers({
      passwordRecovery,
      validateHash,
      validateAccount,
    }),
    reportsActivitiesDoneReducer,
  });
